module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "my-switches"
  }, _vm._l((_vm.switches), function(item, index) {
    return _c('li', {
      staticClass: "switch-item",
      class: {
        'active': _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          _vm.switchItem(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name) + " ")])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6dfe1a3a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/base/MySwitches/MySwitches.vue
// module id = 483
// module chunks = 9